<template>
  <div>
    <v-card
      elevation="0"
      class="pa-md-4 searchResultFinder d-flex justify-space-between flex-column"
      min-height="280"
    >
      <v-row no-gutters class="px-5 d-flex justify-center">
        <v-col cols="12" class="col-md-8">
          <v-row no-gutters justify="center">
            <AutoForm
              :layout="layout"
              :model="entity"
              ref="form"
              v-if="entity"
            />
          </v-row>
          <v-row no-gutters justify="center" class="my-5">
            <v-btn
              x-large
              type="submit"
              color="primary"
              class="font-weight-bold elevation-0 text-none subtitle-1 px-8 py-5 btn-square"
              @click="onSubmit"
              :disabled="isDisable"
            >
              <v-icon size="18" class="mr-2" v-if="typeBtn == 'search'"
                >fal fa-magnifying-glass</v-icon
              >
              {{ getName() }}
              <v-icon size="18" class="ml-2" v-if="typeBtn == 'register'"
                >fas fa-user-plus</v-icon
              >
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import AutoForm from "@/components/Forms/AutoForm";
import PlayerFinderForm from "@/forms/PlayerFinderForm";
const daysDefault = [
          "monday",
          "tuesday",
          "wednesday",
          "thursday",
          "friday",
          "saturday",
          "sunday"
        ];
export default {
  name: "FinderForm",
  components: {
    AutoForm
  },
  props: {
    type: {},
    currentPlayer: {}
  },
  data() {
    return {
      entity: null,
      cities: [],
      states: [],
      cityList: [],
      citySelect: {},
      stateSelect: null,
      stateList: [],
      hasSearch: false,
      isEdit: false,
      typeBtn: "",
      isDisable: false,
    };
  },
  computed: {
    layout() {
      return PlayerFinderForm.layout(
        this.entity,
        this.states,
        this.cities,
        this.type,
        []
      );
    },
  },
  methods: {
    getName() {
      if (this.type === PLAYER_SEEKER) {
        this.typeBtn = "search";
        return this.$gettext("Search");
      } else {
        if (Object.keys(this.currentPlayer).length !== 0) {
          this.typeBtn = "edit";
          return this.$gettext("Save");
        } else {
          this.typeBtn = "register";
          return this.$gettext("Register");
        }
      }
    },
    showError(text) {
      this.$toast.alert(text);
    },
    validateTimeTemporary(elm) {
      let text = ""
      if(elm.timeMode === FINDER_PERMANENTLY) {
        let listDate = [
        elm.mondayHas,
        elm.tuesdayHas,
        elm.wednesdayHas,
        elm.thursdayHas,
        elm.fridayHas,
        elm.saturdayHas,
        elm.sundayHas
        ];
        const check = listDate.some(item => item === true);
        if (!check) {
          text = this.$gettext("Please check day available");
          this.showError(text)
          return false;
        } else {
          daysDefault.forEach(day => {
            if(this.entity[`${day}Has`]) {
              if(this.entity[`${day}To`].length < 5 || this.entity[`${day}From`].length < 5) {
                text = this.$gettextInterpolate(
                  this.$gettext("Invalid time in %{day}"),
                  { day }
                );
              } else if (this.entity[`${day}To`] <= this.entity[`${day}From`]) {
                text = this.$gettextInterpolate(
                  this.$gettext("Please check time from and time to of %{day}"),
                  { day }
                );
              }
              if(text) {
                this.showError(text)
                return false
              }
            }
          })
        }
      } else {
        if(elm.timeTemporary.length === 0){
          text = this.$gettext("Please check day available");
          this.showError(text)
          return false;
        } else {
          for(let i = 0; i < elm.timeTemporary.length; i++) {
            const element = elm.timeTemporary[i]
            if(element[1].length < 5 || element[2].length < 5) {
              text = `Invalid time in date ${element[0]}`
              break;
            } else if(element[1] > element[2]) {
              text = `In ${element[0]} date to must be > date from`
              break;
            }
          }
          if(text) {
            this.showError(text)
            return false;
          }
        }
      }
      return text ? false : true
    },
    resetForm() {
      this.entity = Object.assign({}, PlayerFinderForm.defaultEntity);
    },
    async onSubmit() {
      if (this.$refs.form.validate()) {
        const elm = this.entity;
        let data = JSON.parse(JSON.stringify(elm));
        data.state = data.state.id;
        delete data.country;
        data.filter_country = elm.country.id;
        if(data.city) {
          data.city = data.city.id;
        }
        delete data.courses;
        const courseList = [];
        let result = null;
        let actionName = "searchPlayerFinder";
        if (this.type === PLAYER_HOST) {
          actionName =
            Object.keys(this.currentPlayer).length !== 0
              ? "updateFormHost"
              : "registerFormHost";
          elm.courses.map(item => {
            courseList.push(item.id);
          });
          if (courseList.length == 0) {
            const text = this.$gettext("Please choose course");
            this.$toast.alert(text);
            return;
          }
          const check = this.validateTimeTemporary(elm)
          if(check) {
            data.courses = courseList;
          } else {
            return false
          }
        } else {
          delete data.city;
        }
        // submit
        result = await this.$store.dispatch(actionName, data);
        if (result.error) {
          this.$toast.alert(result.error.message);
        } else {
          const text = this.$gettext("success");
          this.$toast.success(text);
          if (this.type === PLAYER_SEEKER) {
            if (result) {
              this.$emit("setResult", {
                name: "searchResult",
                val: result
              });
              this.$emit("setResult", {
                name: "dateSearch",
                val: { from: data.dateFrom, to: data.dateTo }
              });
            } else {
              this.$emit("setResult", { name: "searchResult", val: [] });
            }
            this.$emit("edit");
            this.$emit("search");
          } else {
            this.$emit("setResult", { name: "currentPlayer", val: result });
            this.$emit("edit");
          }
        }
        // end submit
      }
    }
  },
  watch: {
    "entity.country": {
      async handler(value, oldValue) {
        if (value) {
          this.states = await this.$store.dispatch(
            "location/getStateLocation",
            value.id
          );
        }
        if(this.type === PLAYER_SEEKER) {
          this.cities = [];
        } else if (oldValue && oldValue.id !== value.id) {
          this.cities = []
          this.entity.state = null
          this.entity.city = null;
          this.entity.courses = []
        }
      }
    },
    "entity.state": {
      async handler(value, oldValue) {
        if (value) {
          this.cities = await this.$store.dispatch(
            "location/getCityLocation",
            value.id || value
          );
          if(oldValue && oldValue.id !== value.id) {
            this.entity.city = null;
            this.entity.courses = []
          }
        }
      }
    },
    "entity.dateFrom": {
      immediate: true,
      async handler(value) {
        if (value) {
          this.entity.dateTo = null;
        }
      }
    },
    "entity.timeMode": {
      async handler(value) {
        if(value === FINDER_DAYS) {
          daysDefault.forEach(day => {
          this.entity[`${day}Has`] = false,
          this.entity[`${day}From`] = "";
          this.entity[`${day}To`] = "";
        })
        } else {
          this.entity.timeTemporary = []
        }
      }
    },
  },
  mounted() {
    if (this.currentPlayer.country && this.type === PLAYER_HOST) {
      const value = this.currentPlayer;
      this.entity = JSON.parse(JSON.stringify(value));

      this.entity.mondayHas = !!(value.mondayFrom && value.mondayTo);
      this.entity.tuesdayHas = !!(value.tuesdayFrom && value.tuesdayTo);
      this.entity.wednesdayHas = !!(value.wednesdayFrom && value.wednesdayTo);
      this.entity.thursdayHas = !!(value.thursdayFrom && value.thursdayTo);
      this.entity.fridayHas = !!(value.fridayFrom && value.fridayTo);
      this.entity.saturdayHas = !!(value.saturdayFrom && value.saturdayTo);
      this.entity.sundayHas = !!(value.sundayFrom && value.sundayTo);
    } else {
      this.resetForm();
    }
  }
};
</script>
